import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SummaryLayout from '../../../components/layout/SummaryLayout';
import { getData } from '../../../config/api-connect';
import './logs.css';

function AssetLogs() {
  const { id } = useParams();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await getData('/finance/get_asset_logs/?asset_id=' + id);
        if (r.success) {
          setLogs(r.result.logs);
        }
      } catch {
        message.error('Failed to load asset logs');
      }
      setLoading(false);
    })();
  }, [id]);

  const columns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 160,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 400,
      render: (t) => t && t.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ''),
    },
    {
      title: 'Performed By',
      dataIndex: 'performed_by_name',
      key: 'performed_by_name',
      width: 200,
    },
    {
      title: 'Date',
      dataIndex: 'performed_on',
      key: 'performed_on',
      width: 180,
    },
  ];

  return (
    <div className="asset-logs-page">
      <SummaryLayout
        title="Asset Logs"
        headerContent={
          <Link to="/assets/manage">
            <Button icon={<ArrowLeftOutlined />}>Back to Assets</Button>
          </Link>
        }
        tableProps={{
          data: logs,
          columns,
          rowKey: 'id',
          loading,
          pagination: { pageSize: 20, size: 'small' },
          locale: { emptyText: 'No logs yet' },
        }}
      />
    </div>
  );
}

export default AssetLogs;
